import { z } from 'zod';

import { futuresAppropriatenessAnswersSchema } from '@/services/api/profile/futures-appropriateness';

export const appropriatenessTestQuestionsSchema = futuresAppropriatenessAnswersSchema;

export const appropriatenessTestSchema = appropriatenessTestQuestionsSchema.extend({
  confirmation: z.boolean().default(false),
});

export type AppropriatenessTest = z.infer<typeof appropriatenessTestSchema>;

export const appropriatenessTestFuturesKnowledgeStatementsSchema = appropriatenessTestSchema.pick({
  futuresKnowledgeStatements: true,
});

export type AppropriatenessTestFuturesKnowledgeStatements = z.infer<typeof appropriatenessTestFuturesKnowledgeStatementsSchema>;

export const appropriatenessTestMarginRequirementAtLeverageSchema = appropriatenessTestSchema.pick({
  marginRequirementAtLeverage: true,
});

export type AppropriatenessTestMarginRequirementAtLeverage = z.infer<typeof appropriatenessTestMarginRequirementAtLeverageSchema>;

export const appropriatenessTestMaintenanceMarginBreachSchema = appropriatenessTestSchema.pick({
  maintenanceMarginBreach: true,
});

export type AppropriatenessTestMaintenanceMarginBreach = z.infer<typeof appropriatenessTestMaintenanceMarginBreachSchema>;

export const appropriatenessTestMarginWipeoutPriceMoveSchema = appropriatenessTestSchema.pick({
  marginWipeoutPriceMove: true,
});

export type AppropriatenessTestMarginWipeoutPriceMove = z.infer<typeof appropriatenessTestMarginWipeoutPriceMoveSchema>;

export const appropriatenessTestComplexClassificationReasonSchema = appropriatenessTestSchema.pick({
  complexClassificationReason: true,
});

export type AppropriatenessTestComplexClassificationReason = z.infer<typeof appropriatenessTestComplexClassificationReasonSchema>;

export const appropriatenessTestComplexTransactionCountSchema = appropriatenessTestSchema.pick({
  complexTransactionCount: true,
});

export type AppropriatenessTestComplexTransactionCount = z.infer<typeof appropriatenessTestComplexTransactionCountSchema>;

export const appropriatenessTestAverageComplexTransactionValueSchema = appropriatenessTestSchema.pick({
  averageComplexTransactionValue: true,
});

export type AppropriatenessTestAverageComplexTransactionValue = z.infer<typeof appropriatenessTestAverageComplexTransactionValueSchema>;

export const appropriatenessTestInvestingExperienceLevelSchema = appropriatenessTestSchema.pick({
  investingExperienceLevel: true,
});

export type AppropriatenessTestInvestingExperienceLevel = z.infer<typeof appropriatenessTestInvestingExperienceLevelSchema>;

export const appropriatenessTestRiskAttitudeSchema = appropriatenessTestSchema.pick({
  riskAttitude: true,
});

export type AppropriatenessTestRiskAttitude = z.infer<typeof appropriatenessTestRiskAttitudeSchema>;

export const appropriatenessTestOvernightLossReactionSchema = appropriatenessTestSchema.pick({
  overnightLossReaction: true,
});

export type AppropriatenessTestOvernightLossReaction = z.infer<typeof appropriatenessTestOvernightLossReactionSchema>;

export const appropriatenessTestTotalLossImpactSchema = appropriatenessTestSchema.pick({
  totalLossImpact: true,
});

export type AppropriatenessTestTotalLossImpact = z.infer<typeof appropriatenessTestTotalLossImpactSchema>;

export const appropriatenessTestLeverageAttitudeSchema = appropriatenessTestSchema.pick({
  leverageAttitude: true,
});

export type AppropriatenessTestLeverageAttitude = z.infer<typeof appropriatenessTestLeverageAttitudeSchema>;

export const APPROPRIATENESS_TEST_DEFAULTS = {
  futuresKnowledgeStatements: undefined,
  marginRequirementAtLeverage: undefined,
  maintenanceMarginBreach: undefined,
  marginWipeoutPriceMove: undefined,
  complexClassificationReason: undefined,
  complexTransactionCount: undefined,
  averageComplexTransactionValue: undefined,
  investingExperienceLevel: undefined,
  riskAttitude: undefined,
  overnightLossReaction: undefined,
  totalLossImpact: undefined,
  leverageAttitude: undefined,
} satisfies Partial<AppropriatenessTest>;

export const appropriatenessTestWithDefaultsSchema = appropriatenessTestSchema.partial();

export type AppropriatenessTestOrDefaults = z.infer<typeof appropriatenessTestWithDefaultsSchema>;
